/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * NEXMAIL (Internal)
 * Internal API consumed by the nexmail dashboard.
 * OpenAPI spec version: 0.0.1
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  AuthTokensResponseDto,
  ChooseDesignPathDto,
  CompleteIntegrationStepDto,
  CompleteOnboardingDto,
  ConfirmEmailDto,
  CreateClientStepDto,
  CreateOrganizationStepDto,
  CurrentUserResponseDto,
  ForgotPasswordDto,
  GoogleSigninDto,
  MessageResponseDto,
  OnboardingResponseDto,
  OnboardingStatusResponseDto,
  ProfileResponseDto,
  RefreshTokenDto,
  ResendConfirmationDto,
  ResetPasswordDto,
  SigninDto,
  SignupDto,
  SignupResponseDto,
  SkipStepDto,
  UpdateProfileDto,
} from '.././models';

import { authFetch } from '../../../../lib/api';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Register a new user
 */
export const authControllerSignup = (
  signupDto: SignupDto,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<SignupResponseDto>(
    {
      url: `/api/auth/signup`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: signupDto,
      signal,
    },
    options
  );
};

export const getAuthControllerSignupMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authControllerSignup>>,
    TError,
    { data: SignupDto },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof authControllerSignup>>,
  TError,
  { data: SignupDto },
  TContext
> => {
  const mutationKey = ['authControllerSignup'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authControllerSignup>>,
    { data: SignupDto }
  > = (props) => {
    const { data } = props ?? {};

    return authControllerSignup(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthControllerSignupMutationResult = NonNullable<
  Awaited<ReturnType<typeof authControllerSignup>>
>;
export type AuthControllerSignupMutationBody = SignupDto;
export type AuthControllerSignupMutationError = void;

/**
 * @summary Register a new user
 */
export const useAuthControllerSignup = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof authControllerSignup>>,
      TError,
      { data: SignupDto },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof authControllerSignup>>,
  TError,
  { data: SignupDto },
  TContext
> => {
  const mutationOptions = getAuthControllerSignupMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Sign in with email and password
 */
export const authControllerSignin = (
  signinDto: SigninDto,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<AuthTokensResponseDto>(
    {
      url: `/api/auth/signin`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: signinDto,
      signal,
    },
    options
  );
};

export const getAuthControllerSigninMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authControllerSignin>>,
    TError,
    { data: SigninDto },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof authControllerSignin>>,
  TError,
  { data: SigninDto },
  TContext
> => {
  const mutationKey = ['authControllerSignin'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authControllerSignin>>,
    { data: SigninDto }
  > = (props) => {
    const { data } = props ?? {};

    return authControllerSignin(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthControllerSigninMutationResult = NonNullable<
  Awaited<ReturnType<typeof authControllerSignin>>
>;
export type AuthControllerSigninMutationBody = SigninDto;
export type AuthControllerSigninMutationError = void;

/**
 * @summary Sign in with email and password
 */
export const useAuthControllerSignin = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof authControllerSignin>>,
      TError,
      { data: SigninDto },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof authControllerSignin>>,
  TError,
  { data: SigninDto },
  TContext
> => {
  const mutationOptions = getAuthControllerSigninMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Verifies a Google ID token and signs the user in, linking to an existing account by verified email or creating a new pre-confirmed one.
 * @summary Sign in with Google
 */
export const authControllerGoogleSignin = (
  googleSigninDto: GoogleSigninDto,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<AuthTokensResponseDto>(
    {
      url: `/api/auth/google`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: googleSigninDto,
      signal,
    },
    options
  );
};

export const getAuthControllerGoogleSigninMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authControllerGoogleSignin>>,
    TError,
    { data: GoogleSigninDto },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof authControllerGoogleSignin>>,
  TError,
  { data: GoogleSigninDto },
  TContext
> => {
  const mutationKey = ['authControllerGoogleSignin'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authControllerGoogleSignin>>,
    { data: GoogleSigninDto }
  > = (props) => {
    const { data } = props ?? {};

    return authControllerGoogleSignin(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthControllerGoogleSigninMutationResult = NonNullable<
  Awaited<ReturnType<typeof authControllerGoogleSignin>>
>;
export type AuthControllerGoogleSigninMutationBody = GoogleSigninDto;
export type AuthControllerGoogleSigninMutationError = void;

/**
 * @summary Sign in with Google
 */
export const useAuthControllerGoogleSignin = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof authControllerGoogleSignin>>,
      TError,
      { data: GoogleSigninDto },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof authControllerGoogleSignin>>,
  TError,
  { data: GoogleSigninDto },
  TContext
> => {
  const mutationOptions = getAuthControllerGoogleSigninMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Confirm email address with token
 */
export const authControllerConfirmEmail = (
  confirmEmailDto: ConfirmEmailDto,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<AuthTokensResponseDto>(
    {
      url: `/api/auth/confirm-email`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: confirmEmailDto,
      signal,
    },
    options
  );
};

export const getAuthControllerConfirmEmailMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authControllerConfirmEmail>>,
    TError,
    { data: ConfirmEmailDto },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof authControllerConfirmEmail>>,
  TError,
  { data: ConfirmEmailDto },
  TContext
> => {
  const mutationKey = ['authControllerConfirmEmail'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authControllerConfirmEmail>>,
    { data: ConfirmEmailDto }
  > = (props) => {
    const { data } = props ?? {};

    return authControllerConfirmEmail(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthControllerConfirmEmailMutationResult = NonNullable<
  Awaited<ReturnType<typeof authControllerConfirmEmail>>
>;
export type AuthControllerConfirmEmailMutationBody = ConfirmEmailDto;
export type AuthControllerConfirmEmailMutationError = void;

/**
 * @summary Confirm email address with token
 */
export const useAuthControllerConfirmEmail = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof authControllerConfirmEmail>>,
      TError,
      { data: ConfirmEmailDto },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof authControllerConfirmEmail>>,
  TError,
  { data: ConfirmEmailDto },
  TContext
> => {
  const mutationOptions = getAuthControllerConfirmEmailMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Resend email confirmation link
 */
export const authControllerResendConfirmation = (
  resendConfirmationDto: ResendConfirmationDto,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<MessageResponseDto>(
    {
      url: `/api/auth/resend-confirmation`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: resendConfirmationDto,
      signal,
    },
    options
  );
};

export const getAuthControllerResendConfirmationMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authControllerResendConfirmation>>,
    TError,
    { data: ResendConfirmationDto },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof authControllerResendConfirmation>>,
  TError,
  { data: ResendConfirmationDto },
  TContext
> => {
  const mutationKey = ['authControllerResendConfirmation'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authControllerResendConfirmation>>,
    { data: ResendConfirmationDto }
  > = (props) => {
    const { data } = props ?? {};

    return authControllerResendConfirmation(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthControllerResendConfirmationMutationResult = NonNullable<
  Awaited<ReturnType<typeof authControllerResendConfirmation>>
>;
export type AuthControllerResendConfirmationMutationBody = ResendConfirmationDto;
export type AuthControllerResendConfirmationMutationError = unknown;

/**
 * @summary Resend email confirmation link
 */
export const useAuthControllerResendConfirmation = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof authControllerResendConfirmation>>,
      TError,
      { data: ResendConfirmationDto },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof authControllerResendConfirmation>>,
  TError,
  { data: ResendConfirmationDto },
  TContext
> => {
  const mutationOptions = getAuthControllerResendConfirmationMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Request password reset email
 */
export const authControllerForgotPassword = (
  forgotPasswordDto: ForgotPasswordDto,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<MessageResponseDto>(
    {
      url: `/api/auth/forgot-password`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: forgotPasswordDto,
      signal,
    },
    options
  );
};

export const getAuthControllerForgotPasswordMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authControllerForgotPassword>>,
    TError,
    { data: ForgotPasswordDto },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof authControllerForgotPassword>>,
  TError,
  { data: ForgotPasswordDto },
  TContext
> => {
  const mutationKey = ['authControllerForgotPassword'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authControllerForgotPassword>>,
    { data: ForgotPasswordDto }
  > = (props) => {
    const { data } = props ?? {};

    return authControllerForgotPassword(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthControllerForgotPasswordMutationResult = NonNullable<
  Awaited<ReturnType<typeof authControllerForgotPassword>>
>;
export type AuthControllerForgotPasswordMutationBody = ForgotPasswordDto;
export type AuthControllerForgotPasswordMutationError = unknown;

/**
 * @summary Request password reset email
 */
export const useAuthControllerForgotPassword = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof authControllerForgotPassword>>,
      TError,
      { data: ForgotPasswordDto },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof authControllerForgotPassword>>,
  TError,
  { data: ForgotPasswordDto },
  TContext
> => {
  const mutationOptions = getAuthControllerForgotPasswordMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Reset password with token from email
 */
export const authControllerResetPassword = (
  resetPasswordDto: ResetPasswordDto,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<AuthTokensResponseDto>(
    {
      url: `/api/auth/reset-password`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: resetPasswordDto,
      signal,
    },
    options
  );
};

export const getAuthControllerResetPasswordMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authControllerResetPassword>>,
    TError,
    { data: ResetPasswordDto },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof authControllerResetPassword>>,
  TError,
  { data: ResetPasswordDto },
  TContext
> => {
  const mutationKey = ['authControllerResetPassword'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authControllerResetPassword>>,
    { data: ResetPasswordDto }
  > = (props) => {
    const { data } = props ?? {};

    return authControllerResetPassword(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthControllerResetPasswordMutationResult = NonNullable<
  Awaited<ReturnType<typeof authControllerResetPassword>>
>;
export type AuthControllerResetPasswordMutationBody = ResetPasswordDto;
export type AuthControllerResetPasswordMutationError = void;

/**
 * @summary Reset password with token from email
 */
export const useAuthControllerResetPassword = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof authControllerResetPassword>>,
      TError,
      { data: ResetPasswordDto },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof authControllerResetPassword>>,
  TError,
  { data: ResetPasswordDto },
  TContext
> => {
  const mutationOptions = getAuthControllerResetPasswordMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Refresh access token using refresh token
 */
export const authControllerRefresh = (
  refreshTokenDto: RefreshTokenDto,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<AuthTokensResponseDto>(
    {
      url: `/api/auth/refresh`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: refreshTokenDto,
      signal,
    },
    options
  );
};

export const getAuthControllerRefreshMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authControllerRefresh>>,
    TError,
    { data: RefreshTokenDto },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof authControllerRefresh>>,
  TError,
  { data: RefreshTokenDto },
  TContext
> => {
  const mutationKey = ['authControllerRefresh'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authControllerRefresh>>,
    { data: RefreshTokenDto }
  > = (props) => {
    const { data } = props ?? {};

    return authControllerRefresh(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthControllerRefreshMutationResult = NonNullable<
  Awaited<ReturnType<typeof authControllerRefresh>>
>;
export type AuthControllerRefreshMutationBody = RefreshTokenDto;
export type AuthControllerRefreshMutationError = void;

/**
 * @summary Refresh access token using refresh token
 */
export const useAuthControllerRefresh = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof authControllerRefresh>>,
      TError,
      { data: RefreshTokenDto },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof authControllerRefresh>>,
  TError,
  { data: RefreshTokenDto },
  TContext
> => {
  const mutationOptions = getAuthControllerRefreshMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Return current authenticated user
 */
export const authControllerGetCurrentUser = (
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<CurrentUserResponseDto>({ url: `/api/auth/me`, method: 'GET', signal }, options);
};

export const getAuthControllerGetCurrentUserQueryKey = () => {
  return [`/api/auth/me`] as const;
};

export const getAuthControllerGetCurrentUserQueryOptions = <
  TData = Awaited<ReturnType<typeof authControllerGetCurrentUser>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof authControllerGetCurrentUser>>, TError, TData>
  >;
  request?: SecondParameter<typeof authFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAuthControllerGetCurrentUserQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof authControllerGetCurrentUser>>> = ({
    signal,
  }) => authControllerGetCurrentUser(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof authControllerGetCurrentUser>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AuthControllerGetCurrentUserQueryResult = NonNullable<
  Awaited<ReturnType<typeof authControllerGetCurrentUser>>
>;
export type AuthControllerGetCurrentUserQueryError = void;

export function useAuthControllerGetCurrentUser<
  TData = Awaited<ReturnType<typeof authControllerGetCurrentUser>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof authControllerGetCurrentUser>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof authControllerGetCurrentUser>>,
          TError,
          Awaited<ReturnType<typeof authControllerGetCurrentUser>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAuthControllerGetCurrentUser<
  TData = Awaited<ReturnType<typeof authControllerGetCurrentUser>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof authControllerGetCurrentUser>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof authControllerGetCurrentUser>>,
          TError,
          Awaited<ReturnType<typeof authControllerGetCurrentUser>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAuthControllerGetCurrentUser<
  TData = Awaited<ReturnType<typeof authControllerGetCurrentUser>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof authControllerGetCurrentUser>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Return current authenticated user
 */

export function useAuthControllerGetCurrentUser<
  TData = Awaited<ReturnType<typeof authControllerGetCurrentUser>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof authControllerGetCurrentUser>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAuthControllerGetCurrentUserQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update profile information for the authenticated user
 * @summary Update current user profile
 */
export const authControllerUpdateProfile = (
  updateProfileDto: UpdateProfileDto,
  options?: SecondParameter<typeof authFetch>
) => {
  return authFetch<ProfileResponseDto>(
    {
      url: `/api/auth/me`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: updateProfileDto,
    },
    options
  );
};

export const getAuthControllerUpdateProfileMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authControllerUpdateProfile>>,
    TError,
    { data: UpdateProfileDto },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof authControllerUpdateProfile>>,
  TError,
  { data: UpdateProfileDto },
  TContext
> => {
  const mutationKey = ['authControllerUpdateProfile'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authControllerUpdateProfile>>,
    { data: UpdateProfileDto }
  > = (props) => {
    const { data } = props ?? {};

    return authControllerUpdateProfile(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthControllerUpdateProfileMutationResult = NonNullable<
  Awaited<ReturnType<typeof authControllerUpdateProfile>>
>;
export type AuthControllerUpdateProfileMutationBody = UpdateProfileDto;
export type AuthControllerUpdateProfileMutationError = void;

/**
 * @summary Update current user profile
 */
export const useAuthControllerUpdateProfile = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof authControllerUpdateProfile>>,
      TError,
      { data: UpdateProfileDto },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof authControllerUpdateProfile>>,
  TError,
  { data: UpdateProfileDto },
  TContext
> => {
  const mutationOptions = getAuthControllerUpdateProfileMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Logout and revoke refresh token
 */
export const authControllerLogout = (
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<MessageResponseDto>(
    { url: `/api/auth/logout`, method: 'POST', signal },
    options
  );
};

export const getAuthControllerLogoutMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authControllerLogout>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof authControllerLogout>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['authControllerLogout'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authControllerLogout>>,
    void
  > = () => {
    return authControllerLogout(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthControllerLogoutMutationResult = NonNullable<
  Awaited<ReturnType<typeof authControllerLogout>>
>;

export type AuthControllerLogoutMutationError = unknown;

/**
 * @summary Logout and revoke refresh token
 */
export const useAuthControllerLogout = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof authControllerLogout>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof authControllerLogout>>, TError, void, TContext> => {
  const mutationOptions = getAuthControllerLogoutMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Creates an organization for a new user and makes them the owner. For brand orgs, also creates a default client.
 * @summary Complete user onboarding by creating organization
 */
export const authControllerCompleteOnboarding = (
  completeOnboardingDto: CompleteOnboardingDto,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<OnboardingResponseDto>(
    {
      url: `/api/auth/onboarding`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: completeOnboardingDto,
      signal,
    },
    options
  );
};

export const getAuthControllerCompleteOnboardingMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authControllerCompleteOnboarding>>,
    TError,
    { data: CompleteOnboardingDto },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof authControllerCompleteOnboarding>>,
  TError,
  { data: CompleteOnboardingDto },
  TContext
> => {
  const mutationKey = ['authControllerCompleteOnboarding'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authControllerCompleteOnboarding>>,
    { data: CompleteOnboardingDto }
  > = (props) => {
    const { data } = props ?? {};

    return authControllerCompleteOnboarding(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthControllerCompleteOnboardingMutationResult = NonNullable<
  Awaited<ReturnType<typeof authControllerCompleteOnboarding>>
>;
export type AuthControllerCompleteOnboardingMutationBody = CompleteOnboardingDto;
export type AuthControllerCompleteOnboardingMutationError = void;

/**
 * @summary Complete user onboarding by creating organization
 */
export const useAuthControllerCompleteOnboarding = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof authControllerCompleteOnboarding>>,
      TError,
      { data: CompleteOnboardingDto },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof authControllerCompleteOnboarding>>,
  TError,
  { data: CompleteOnboardingDto },
  TContext
> => {
  const mutationOptions = getAuthControllerCompleteOnboardingMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Returns the current step and status of the onboarding flow for the authenticated user
 * @summary Get current onboarding status
 */
export const authControllerGetOnboardingStatus = (
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<OnboardingStatusResponseDto>(
    { url: `/api/auth/onboarding/status`, method: 'GET', signal },
    options
  );
};

export const getAuthControllerGetOnboardingStatusQueryKey = () => {
  return [`/api/auth/onboarding/status`] as const;
};

export const getAuthControllerGetOnboardingStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof authControllerGetOnboardingStatus>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof authControllerGetOnboardingStatus>>, TError, TData>
  >;
  request?: SecondParameter<typeof authFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAuthControllerGetOnboardingStatusQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof authControllerGetOnboardingStatus>>> = ({
    signal,
  }) => authControllerGetOnboardingStatus(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof authControllerGetOnboardingStatus>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AuthControllerGetOnboardingStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof authControllerGetOnboardingStatus>>
>;
export type AuthControllerGetOnboardingStatusQueryError = void;

export function useAuthControllerGetOnboardingStatus<
  TData = Awaited<ReturnType<typeof authControllerGetOnboardingStatus>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof authControllerGetOnboardingStatus>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof authControllerGetOnboardingStatus>>,
          TError,
          Awaited<ReturnType<typeof authControllerGetOnboardingStatus>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAuthControllerGetOnboardingStatus<
  TData = Awaited<ReturnType<typeof authControllerGetOnboardingStatus>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof authControllerGetOnboardingStatus>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof authControllerGetOnboardingStatus>>,
          TError,
          Awaited<ReturnType<typeof authControllerGetOnboardingStatus>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAuthControllerGetOnboardingStatus<
  TData = Awaited<ReturnType<typeof authControllerGetOnboardingStatus>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof authControllerGetOnboardingStatus>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get current onboarding status
 */

export function useAuthControllerGetOnboardingStatus<
  TData = Awaited<ReturnType<typeof authControllerGetOnboardingStatus>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof authControllerGetOnboardingStatus>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAuthControllerGetOnboardingStatusQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Creates an organization for the user. For brand orgs, also creates default client and brand profile.
 * @summary Create organization (onboarding step 2)
 */
export const authControllerCreateOrganizationStep = (
  createOrganizationStepDto: CreateOrganizationStepDto,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<OnboardingStatusResponseDto>(
    {
      url: `/api/auth/onboarding/organization`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createOrganizationStepDto,
      signal,
    },
    options
  );
};

export const getAuthControllerCreateOrganizationStepMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authControllerCreateOrganizationStep>>,
    TError,
    { data: CreateOrganizationStepDto },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof authControllerCreateOrganizationStep>>,
  TError,
  { data: CreateOrganizationStepDto },
  TContext
> => {
  const mutationKey = ['authControllerCreateOrganizationStep'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authControllerCreateOrganizationStep>>,
    { data: CreateOrganizationStepDto }
  > = (props) => {
    const { data } = props ?? {};

    return authControllerCreateOrganizationStep(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthControllerCreateOrganizationStepMutationResult = NonNullable<
  Awaited<ReturnType<typeof authControllerCreateOrganizationStep>>
>;
export type AuthControllerCreateOrganizationStepMutationBody = CreateOrganizationStepDto;
export type AuthControllerCreateOrganizationStepMutationError = void;

/**
 * @summary Create organization (onboarding step 2)
 */
export const useAuthControllerCreateOrganizationStep = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof authControllerCreateOrganizationStep>>,
      TError,
      { data: CreateOrganizationStepDto },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof authControllerCreateOrganizationStep>>,
  TError,
  { data: CreateOrganizationStepDto },
  TContext
> => {
  const mutationOptions = getAuthControllerCreateOrganizationStepMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Creates the first client for an agency organization, then lands them on the design path fork -- the brand the fork acts on has to exist before it can be offered. Brand organizations skip this step and reach the fork straight from the organization step.
 * @summary Create first client (onboarding step 3 - agencies only)
 */
export const authControllerCreateClientStep = (
  createClientStepDto: CreateClientStepDto,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<OnboardingStatusResponseDto>(
    {
      url: `/api/auth/onboarding/client`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createClientStepDto,
      signal,
    },
    options
  );
};

export const getAuthControllerCreateClientStepMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authControllerCreateClientStep>>,
    TError,
    { data: CreateClientStepDto },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof authControllerCreateClientStep>>,
  TError,
  { data: CreateClientStepDto },
  TContext
> => {
  const mutationKey = ['authControllerCreateClientStep'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authControllerCreateClientStep>>,
    { data: CreateClientStepDto }
  > = (props) => {
    const { data } = props ?? {};

    return authControllerCreateClientStep(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthControllerCreateClientStepMutationResult = NonNullable<
  Awaited<ReturnType<typeof authControllerCreateClientStep>>
>;
export type AuthControllerCreateClientStepMutationBody = CreateClientStepDto;
export type AuthControllerCreateClientStepMutationError = void;

/**
 * @summary Create first client (onboarding step 3 - agencies only)
 */
export const useAuthControllerCreateClientStep = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof authControllerCreateClientStep>>,
      TError,
      { data: CreateClientStepDto },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof authControllerCreateClientStep>>,
  TError,
  { data: CreateClientStepDto },
  TContext
> => {
  const mutationOptions = getAuthControllerCreateClientStepMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Skips the current onboarding step and advances to the next one. Skipping the design path fork or the integration step finishes onboarding, since neither has a step after it.
 * @summary Skip an onboarding step
 */
export const authControllerSkipOnboardingStep = (
  skipStepDto: SkipStepDto,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<OnboardingStatusResponseDto>(
    {
      url: `/api/auth/onboarding/skip`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: skipStepDto,
      signal,
    },
    options
  );
};

export const getAuthControllerSkipOnboardingStepMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authControllerSkipOnboardingStep>>,
    TError,
    { data: SkipStepDto },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof authControllerSkipOnboardingStep>>,
  TError,
  { data: SkipStepDto },
  TContext
> => {
  const mutationKey = ['authControllerSkipOnboardingStep'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authControllerSkipOnboardingStep>>,
    { data: SkipStepDto }
  > = (props) => {
    const { data } = props ?? {};

    return authControllerSkipOnboardingStep(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthControllerSkipOnboardingStepMutationResult = NonNullable<
  Awaited<ReturnType<typeof authControllerSkipOnboardingStep>>
>;
export type AuthControllerSkipOnboardingStepMutationBody = SkipStepDto;
export type AuthControllerSkipOnboardingStepMutationError = void;

/**
 * @summary Skip an onboarding step
 */
export const useAuthControllerSkipOnboardingStep = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof authControllerSkipOnboardingStep>>,
      TError,
      { data: SkipStepDto },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof authControllerSkipOnboardingStep>>,
  TError,
  { data: SkipStepDto },
  TContext
> => {
  const mutationOptions = getAuthControllerSkipOnboardingStepMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Marks the integration onboarding step as completed. Integration is the last step of the free design path, so this finishes onboarding.
 * @summary Mark the integration step as complete
 */
export const authControllerCompleteIntegrationStep = (
  completeIntegrationStepDto: CompleteIntegrationStepDto,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<OnboardingStatusResponseDto>(
    {
      url: `/api/auth/onboarding/integration`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: completeIntegrationStepDto,
      signal,
    },
    options
  );
};

export const getAuthControllerCompleteIntegrationStepMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authControllerCompleteIntegrationStep>>,
    TError,
    { data: CompleteIntegrationStepDto },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof authControllerCompleteIntegrationStep>>,
  TError,
  { data: CompleteIntegrationStepDto },
  TContext
> => {
  const mutationKey = ['authControllerCompleteIntegrationStep'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authControllerCompleteIntegrationStep>>,
    { data: CompleteIntegrationStepDto }
  > = (props) => {
    const { data } = props ?? {};

    return authControllerCompleteIntegrationStep(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthControllerCompleteIntegrationStepMutationResult = NonNullable<
  Awaited<ReturnType<typeof authControllerCompleteIntegrationStep>>
>;
export type AuthControllerCompleteIntegrationStepMutationBody = CompleteIntegrationStepDto;
export type AuthControllerCompleteIntegrationStepMutationError = void;

/**
 * @summary Mark the integration step as complete
 */
export const useAuthControllerCompleteIntegrationStep = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof authControllerCompleteIntegrationStep>>,
      TError,
      { data: CompleteIntegrationStepDto },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof authControllerCompleteIntegrationStep>>,
  TError,
  { data: CompleteIntegrationStepDto },
  TContext
> => {
  const mutationOptions = getAuthControllerCompleteIntegrationStepMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Records which path the user wants -- the two free designs, White Glove now, or the Figma plugin -- and advances to it. Can be called again to switch while onboarding is still in progress. `figma` is offered to agencies only and is refused on a single-brand account. The path resolves when its own evidence exists for the brand (a White Glove engagement, or the Figma billing tier), which the status endpoint derives -- there is no endpoint to call for it. The free and Figma paths then land on the integration step; the White Glove path finishes onboarding outright, because its intake wizard asks for the same integrations itself.
 * @summary Choose a design path (onboarding fork)
 */
export const authControllerChooseDesignPath = (
  chooseDesignPathDto: ChooseDesignPathDto,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<OnboardingStatusResponseDto>(
    {
      url: `/api/auth/onboarding/design-path`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: chooseDesignPathDto,
      signal,
    },
    options
  );
};

export const getAuthControllerChooseDesignPathMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authControllerChooseDesignPath>>,
    TError,
    { data: ChooseDesignPathDto },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof authControllerChooseDesignPath>>,
  TError,
  { data: ChooseDesignPathDto },
  TContext
> => {
  const mutationKey = ['authControllerChooseDesignPath'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authControllerChooseDesignPath>>,
    { data: ChooseDesignPathDto }
  > = (props) => {
    const { data } = props ?? {};

    return authControllerChooseDesignPath(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthControllerChooseDesignPathMutationResult = NonNullable<
  Awaited<ReturnType<typeof authControllerChooseDesignPath>>
>;
export type AuthControllerChooseDesignPathMutationBody = ChooseDesignPathDto;
export type AuthControllerChooseDesignPathMutationError = void;

/**
 * @summary Choose a design path (onboarding fork)
 */
export const useAuthControllerChooseDesignPath = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof authControllerChooseDesignPath>>,
      TError,
      { data: ChooseDesignPathDto },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof authControllerChooseDesignPath>>,
  TError,
  { data: ChooseDesignPathDto },
  TContext
> => {
  const mutationOptions = getAuthControllerChooseDesignPathMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Marks the onboarding as completed. Can be called to finish onboarding regardless of step status.
 * @summary Complete the onboarding flow
 */
export const authControllerCompleteOnboardingFlow = (
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<OnboardingStatusResponseDto>(
    { url: `/api/auth/onboarding/complete`, method: 'POST', signal },
    options
  );
};

export const getAuthControllerCompleteOnboardingFlowMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authControllerCompleteOnboardingFlow>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof authControllerCompleteOnboardingFlow>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['authControllerCompleteOnboardingFlow'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authControllerCompleteOnboardingFlow>>,
    void
  > = () => {
    return authControllerCompleteOnboardingFlow(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthControllerCompleteOnboardingFlowMutationResult = NonNullable<
  Awaited<ReturnType<typeof authControllerCompleteOnboardingFlow>>
>;

export type AuthControllerCompleteOnboardingFlowMutationError = void;

/**
 * @summary Complete the onboarding flow
 */
export const useAuthControllerCompleteOnboardingFlow = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof authControllerCompleteOnboardingFlow>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof authControllerCompleteOnboardingFlow>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getAuthControllerCompleteOnboardingFlowMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
